"use strict";

// 为了解决iframe下嵌套页面event不生效的问题
var inputElement = document.createElement('input');

inputElement.onfocus = function (event) {
  // @ts-ignore
  event.target.blur();
  document.body.removeChild(inputElement);
};

inputElement.style.width = '0px';
document.body.appendChild(inputElement);
setTimeout(function () {
  inputElement.focus();
});